import generateUUID from "./generateUUID";

const UUID = {
  generateUUID
};

export default UUID;
